export const appName = 'brizup'
export const isDev = process.env.NODE_ENV !== 'production'